import React from 'react';

import { faStar } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Badge } from '@buildoutinc/blueprint-react/ui/Badge';
import { Tooltip } from '@buildoutinc/blueprint-react/ui/Tooltip';
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
} from '@buildoutinc/blueprint-react/ui/Table';

import { PROVIDER_DISPLAY } from './providers';
import type { ProviderEnum } from './types';

interface Props {
  connectedProvider: ProviderEnum | null;
  orderedProviders: ProviderEnum[];
  constantContactPromotion: string;
  onDisconnect: () => void;
  onSelectProvider: (provider: ProviderEnum) => void;
}

export function Providers({
  connectedProvider,
  orderedProviders,
  constantContactPromotion,
  onDisconnect,
  onSelectProvider,
}: Props) {
  return (
    <div>
      <h6 className="mb-4">Connected Provider</h6>
      {connectedProvider ? (
        <Table className="table-hover border-top">
          <TableBody>
            <TableRow className="align-middle">
              <TableCell>
                <img
                  alt={PROVIDER_DISPLAY[connectedProvider].label}
                  className="mw-100 provider-logo-small"
                  src={PROVIDER_DISPLAY[connectedProvider].logo}
                  style={PROVIDER_DISPLAY[connectedProvider].style}
                />
              </TableCell>
              <TableCell className="text-end">
                <a
                  className="text-danger"
                  href="#"
                  onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
                    e.preventDefault();
                    onDisconnect();
                  }}
                >
                  Disconnect
                </a>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      ) : (
        <div className="card">
          <div className="card-body text-center">
            <div className="fs-large fw-light my-2">No Email Provider Connected</div>
            <p className="mb-2">To send emails from Buildout, connect an Email Provider from the list below.</p>
          </div>
        </div>
      )}

      <h6 className="mt-7 mb-4">Available Email Providers</h6>
      <Table className="table-hover border-top">
        <TableBody>
          {orderedProviders.map((provider) => {
            const providerDisplay = PROVIDER_DISPLAY[provider];

            return (
              <TableRow className="align-middle" key={provider}>
                <TableCell>
                  <img
                    alt={providerDisplay.label}
                    className="mw-100 provider-logo-small"
                    src={providerDisplay.logo}
                    style={providerDisplay.style}
                  />
                </TableCell>
                <TableCell className="text-end">
                  <a
                    data-provider={provider}
                    href="#"
                    onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
                      e.preventDefault();
                      onSelectProvider(provider);
                    }}
                  >
                    Connect Account
                  </a>
                </TableCell>
                <TableCell className="text-end">
                  {providerDisplay.signUpUrl && (
                    <a href={providerDisplay.signUpUrl} rel="noreferrer" target="_blank">Sign Up Here</a>
                  )}
                </TableCell>
                <TableCell>
                  {providerDisplay.showPromotion && (
                    <div className="d-none d-sm-block">
                      <Tooltip>
                        <Tooltip.Trigger
                          render={(
                            <Badge variant="secondary">
                              <FontAwesomeIcon icon={faStar} /> Up to 20% off
                            </Badge>
                          )}
                        />
                        <Tooltip.Content>
                          <span dangerouslySetInnerHTML={{ __html: constantContactPromotion }} />
                        </Tooltip.Content>
                      </Tooltip>
                    </div>
                  )}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
}
